import { createActions, using } from "redux-box";

export default createActions({
  requestList: using(),
  requestListByOffset: using("offset"),
  setSearch: using("search"),
  setVoiceFilter: using("voice"),
  requestCreate: using("data"),
  requestUpdate: using("id, data"),
  requestDelete: using("id"),
  setSelected: using("entry"),
  requestVoices: using(),
});
